import { RequestError, RequestErrorArgs } from "./RequestError"

export class TimeoutError extends RequestError {
  constructor(args: Omit<RequestErrorArgs, "response">) {
    super({ ...args, response: null })
    this.name = "TimeoutError"
  }
}
